import React from 'react'

import { bool, func, object } from 'prop-types'

import Navbar from './Navbar'

const NewHeader = ({ actionContent, showMobileNotification, hideMobileNotification }) => (
  <div id="header">
    <Navbar actionContent={actionContent} hideMobileNotification={hideMobileNotification} showMobileNotification={showMobileNotification} />
  </div>
)

NewHeader.propTypes = {
  actionContent: object,
  hideMobileNotification: bool,
  showMobileNotification: func,
}

export default NewHeader
